export const Events = [
	{
		id:"hsppc2016",
		title:'HSPプログラムコンテスト2016 入賞',
		description:'「Goodbyeborder」JBOYSOFT賞 受賞',
		start:'2016-12-01',
		end:'2016-12-01',
		backgroundColor:'green',
		borderColor:'red',
		editable:false

	},

	{
		id:"kk13",
		title:'けもケット13 サークル参加',
		description:'スペースNo.【 J-06 】\n "ひとりよがり工房" 初サークル参加 ',
		start:'2023-05-06',
		end:'2023-05-06',
		backgroundColor:'green',
		borderColor:'red',
		editable:false

	},

	{
		id:"kk14",
		title:'けもケット14 サークル参加',
		description:'スペースNo.【 R-07 】\n 「魔法少女はおやすみ！」頒布 ',
		start:'2023-09-17',
		end:'2023-09-17',
		backgroundColor:'green',
		borderColor:'red',
		editable:false

	},

	{
		id:"kkk9",
		title:'関西けもケット9 サークル参加',
		description:'スペースNo.【 D-40 】\n 「シュガビタエブリデイズ その①」頒布 ',
		start:'2024-05-19',
		end:'2024-05-19',
		backgroundColor:'green',
		borderColor:'red',
		editable:false

	},

	{
		id:"comitia148",
		title:'COMITIA148 サークル参加',
		description:'スペースNo.【 つ-51a 】\n 準新刊/既刊のみ頒布 ',
		start:'2024-05-26',
		end:'2024-05-26',
		backgroundColor:'green',
		borderColor:'red',
		editable:false

	},

	{
		id:"hhm2",
		title:'ひぃふぅみぃ!!つー サークル参加',
		description:'スペースNo.【 ひ-07 】\n 準新刊/既刊のみ頒布 ',
		start:'2024-06-23',
		end:'2024-06-23',
		backgroundColor:'green',
		borderColor:'red',
		editable:false

	},

	{
		id:"skk11",
		title:'新春けもケット11 サークル参加',
		description:'スペースNo.【 D-37 】\n 「なにこれちろる」頒布 ',
		start:'2025-01-19',
		end:'2025-01-19',
		backgroundColor:'green',
		borderColor:'red',
		editable:false

	},

	{
		id:"kkk10",
		title:'関西けもケット10 サークル参加',
		description:'スペースNo.【 F-04 】\n 「シュガビタエブリデイズ その②」頒布 ',
		start:'2025-05-18',
		end:'2025-05-18',
		backgroundColor:'green',
		borderColor:'red',
		editable:false

	},

	{
		id:"comitia152",
		title:'COMITTIA152 サークル参加',
		description:'スペースNo.【 ぬ-37a 】\n 準新刊/既刊のみ頒布 ',
		start:'2025-06-01T11:00:00',
		end:'2025-06-01T16:00:00',
		backgroundColor:'green',
		borderColor:'red',
		editable:false

	},

	{
		id:"FLiP2025",
		title:'FLiP2025 サークル参加',
		description:'スペースNo.【 E-08 】\n 「躁のイマジア(1)」頒布 ',
		start:'2025-11-29T12:00:00',
		end:'2025-11-29T16:00:00',
		link:'東京たま未来メッセ',
		backgroundColor:'green',
		borderColor:'red',
		editable:false

	},

	{
		id:"hhm3",
		title:'ひぃふぅみぃ!!SUN サークル参加',
		description:'スペースNo.【 ひ-03 】\n 「月とクローバーは交わらない」頒布 ',
		start:'2026-03-01T11:30:00',
		end:'2026-03-01T16:00:00',
		link:'日本橋浜町プラザマーム 3階展示室',
		backgroundColor:'green',
		borderColor:'red',
		editable:false

	},

	{
		id:"kkk11",
		title:'関西けもケット11 サークル参加',
		description:'スペースNo.【 C-52 】 \n「たったひとつのしあわせ」 頒布\nhttps://skypalette.jp/kemoket/',
		start:'2026-04-19',
		end:'2026-04-19',
		link:'インテックス大阪 4号館',
		backgroundColor:'green',
		borderColor:'red',
		editable:false
	}

];

export default Events;